import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'
import { useContext } from 'react'
import ApplicationContext from 'platform/react/context/application'
import { getSubLabel } from 'lib/util/string'

const styles = () => ({
  row: {
    gap: 12,
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: 4,
  },
})

/**
 * Displays the name of an organisation.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellDashboardOrganisationName = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const { address = {}, number = '', name = '-' } = props || {}
  const subLabel = getSubLabel(Text, [number, intl.address(address, { inline: true })])

  return (
    <Grid
      container
      direction={'row'}
      className={classes.row}
    >
      <Grid
        item
        xs={'auto'}
        alignSelf={'stretch'}
      >
        <Grid
          container
          gap={'0.125rem'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}

          sx={{ height: '100%' }}
        >
          <Text
            maxLines={1}
            value={name}
            variant={'14/bold'}
            color={'black.main'}
          />
          {address && number && (
            <Grid
              container
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardOrganisationName, styles)
